// extracted by css-extract-rspack-plugin
export default {"cls1":"AccountMenuButton-cls1_e9M","cls2":"AccountMenuButton-cls2_-FF AccountMenuButton-cls1_e9M","redesign":"AccountMenuButton-redesign_Fgd"};